import "./NotificationModals.css";
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../redux/store';
import { fetchNotificationById } from "../../../redux/actions/notifications.actions";
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import ModalShell, { ModalLoading } from "../../../components/common/Modals/ModalShell";

const NotificationDetailsModal: React.FC<ModalProps> = ({open, setOpen, object}) => {
    const dispatch = useDispatch<AppDispatch>();
    const [notif, setNotif] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
      if (open && object?.id) {
        setLoading(true);
        setError(null);
        dispatch(fetchNotificationById(object.id))
          .unwrap()
          .then((data) => { setNotif(data); setLoading(false); })
          .catch((err) => { setError(err); setLoading(false); });
      }
    }, [open, object?.id, dispatch]);

    const handleClose = () => { setNotif(null); setOpen(false); };

    const getStatusChip = (n: any) => {
      if (n.is_sent) return <span className="ntf-status good">Sent</span>;
      if (n.scheduled_at) return <span className="ntf-status info">Scheduled</span>;
      return <span className="ntf-status caution">Pending</span>;
    };

    return (
      <ModalShell
        open={open}
        onClose={handleClose}
        size={notif && !loading && !error ? "md" : "sm"}
        tone={!loading && error ? "error" : undefined}
        title={loading ? "Loading…" : error ? "Error" : notif ? notif.title : ""}
        subtitle={!loading && !error && notif ? getStatusChip(notif) : undefined}
        actions={loading || (!error && !notif) ? undefined :
          <button className="btn btn-primary" onClick={handleClose}>Close</button>
        }
      >
        {loading ? (
          <ModalLoading/>
        ) : error ? (
          <p>{error}</p>
        ) : notif ? (
          <>
            {notif.image_url && (
              <img className="ntf-image" src={notif.image_url} alt={notif.title} />
            )}
            <p className="ntf-text">{notif.text}</p>

            {notif.url && (
              <p>
                <strong>URL:</strong> <a className="ntf-link" href={notif.url} target="_blank" rel="noopener noreferrer">{notif.url}</a>
              </p>
            )}

            {(notif.scheduled_at || notif.sent_at) && (
              <div className="ntf-dates">
                {notif.scheduled_at && (
                  <span className="ntf-date">Scheduled: {new Date(notif.scheduled_at).toLocaleString()}</span>
                )}
                {notif.sent_at && (
                  <span className="ntf-date">Sent: {new Date(notif.sent_at).toLocaleString()}</span>
                )}
              </div>
            )}

            {notif.dealerships && notif.dealerships.length > 0 && (
              <div className="dlg-section">
                <span className="dlg-label">Dealerships ({notif.dealerships.length})</span>
                <ul className="dlg-spa-list">
                  {notif.dealerships.map((d: any) => (
                    <li key={d.id}>
                      <span className="dlg-spa-name">{d.name}</span>
                      <span className="dlg-mono">ID: {d.id}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {notif.users && notif.users.length > 0 && (
              <div className="dlg-section">
                <span className="dlg-label">Users ({notif.users.length})</span>
                <ul className="dlg-spa-list">
                  {notif.users.map((u: any) => (
                    <li key={u.id}>
                      <span className="dlg-spa-name">{u.email}</span>
                      {u.name && <span className="dlg-muted">{u.name}</span>}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </>
        ) : null}
      </ModalShell>
    );
};

export default NotificationDetailsModal;
